import React, {Component} from 'react';
import {connect} from 'react-redux';
import {clone, mergeDeepLeft, path} from 'ramda';
import DatePicker from "../../common/DatePicker";
import {Modal, ModalBody, ModalHeader} from 'reactstrap'
import {changeModalState} from '../../actions/modal'
import Input from "../../common/Input";
import {validateFields} from "../../utils/validate";
import './style.css';
import ReactSelectWrapper from "../../common/ReactSelectWrapper";
import {formatUnixTimestampForDatePicker} from "../../utils/date";

class CreateActivityPopup extends Component {

  constructor(props) {
    super(props);

    this.state = {
      workerOptions: [],
      activityOptions: [],
      modal: false,
      wrapClassName: 'modal-default',
      size: 'default',
      fields: clone({
        worker: {
          label: 'Worker',
          placeholder: 'Select...',
          system: {
            component: Input,
            name: 'worker'
          },
          value: '',
          errors: [],
          type: 'text',
          name: 'worker',
          rules: {
            title: 'Worker',
          }
        },
        activity: {
          label: 'Activity',
          placeholder: 'Activity',
          system: {
            component: Input,
            name: 'activity'
          },
          value: '',
          errors: [],
          type: 'text',
          name: 'activity',
          rules: {
            title: 'Activity',
          }
        },
        wo_number: {
          label: 'Work Order',
          placeholder: 'Work Order',
          system: {
            component: Input,
            name: 'wo_number'
          },
          value: '',
          errors: [],
          type: 'text',
          name: 'wo_number',
          rules: {
            title: 'Work Order',
          }
        },
        started_at: {
          label: 'Started',
          placeholder: 'Pick a date',
          system: {
            component: DatePicker,
            name: 'started_at'
          },
          value: '',
          errors: [],
          type: 'text',
          name: 'started_at',
          rules: {
            title: 'Pick a datetime',
          },
          timeFormat: true,
        },
        stopped_at: {
          label: 'Finished',
          placeholder: 'Pick a date',
          system: {
            component: DatePicker,
            name: 'stopped_at'
          },
          value: '',
          errors: [],
          type: 'text',
          name: 'stopped_at',
          rules: {
            title: 'Pick a datetime',
          },
          timeFormat: true,
        },
      })
    };

    this.toggle = this.toggle.bind(this);
    this.cancel = this.cancel.bind(this);
    this.submit = this.submit.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
  }

  componentWillReceiveProps(newProps) {
    const workers = path(['employees', 'workers'], newProps);
    const stagesList = path(['boardSettings', 'stages'], newProps);

    let stateClone = clone(this.state);

    if (workers && workers.length) {
      stateClone.workerOptions = workers.map(worker => ({
          label: `${worker.firstname} ${worker.lastname}`,
          value: worker.id
        }))
    }

    if (stagesList && stagesList.length) {
      stateClone.activityOptions = stagesList.map(stage => ({
        label: stage.label,
        value: stage.id,
      }))
    }

    let wo_number = path(['modal', 'wo_number'], newProps);
    let started_at = path(['modal', 'started_at'], newProps);
    let stopped_at = path(['modal', 'stopped_at'], newProps);
    let worker = path(['modal', 'worker'], newProps);
    let activity = path(['modal', 'activity'], newProps);

    stateClone.fields['wo_number'].value = wo_number;
    stateClone.fields['started_at'].value = formatUnixTimestampForDatePicker(started_at);
    stateClone.fields['stopped_at'].value = formatUnixTimestampForDatePicker(stopped_at);
    stateClone.fields['worker'].value = worker;
    stateClone.fields['activity'].value = activity;

    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  toggle() {
    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen
    });
  }

  clearFields() {
    let stateClone = clone(this.state);
    for (let i in stateClone.fields) {
      stateClone.fields[i].value = "";
    }
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  cancel() {
    this.clearFields();
    this.toggle();
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);

    if (typeof field === 'object') {
      // FIX: add support of multiple levels
      stateClone.fields[field[0]][field[2]] = newObject;
    } else {
      stateClone.fields[field] = newObject;
    }

    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  submit(e) {
    e.preventDefault();
    let result = validateFields(this.state.fields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      const id = path(['modal', 'id'], this.props);
      let handler = path(['modal', 'handler'], this.props);

      let started_at = result.fields['started_at'].value;
      let stopped_at = result.fields['stopped_at'].value;
      let worker = result.fields['worker'].value;
      let activity = result.fields['activity'].value;
      let wo_number = result.fields['wo_number'].value;

      this.props.createAction({
        id: id,
        started_at: started_at,
        stopped_at: stopped_at,
        wo_number: wo_number,
        worker: worker,
        activity: activity
      }, handler);
      this.toggle();
    }
    return false;
  }

  render() {
    let modalId = path(['modal', 'modalId'], this.props);
    let showModal = this.props.modal.isOpen;
    if (modalId && modalId !== this.props.id) {
      showModal = false;
    }

    return (
      <Modal
        isOpen={showModal}
        toggle={this.toggle}
        wrapClassName={this.state.wrapClassName}
        size={this.state.size}
      >

        <ModalHeader>Please enter the correct data</ModalHeader>
        <ModalBody>
          <div>
            <form onSubmit={this.submit}>
              <ReactSelectWrapper
                options={this.state.workerOptions}
                field={this.state.fields['worker']}
                onChange={this.changeFormValue}
              />
              <ReactSelectWrapper
                options={this.state.activityOptions}
                field={this.state.fields['activity']}
                onChange={this.changeFormValue}
              />
              <Input
                field={this.state.fields['wo_number']}
                onChange={this.changeFormValue}
              />
              <DatePicker
                field={this.state.fields['started_at']}
                useLocalTimeZone={true}
                onChange={this.changeFormValue}
              />
              <DatePicker
                field={this.state.fields['stopped_at']}
                useLocalTimeZone={true}
                onChange={this.changeFormValue}
              />
            </form>
          </div>
          <div className="clearfix pull-right">
            <button className="btn btn-default mr-1" onClick={this.cancel}>
              Cancel
            </button>
            <button className="btn btn-default" onClick={this.submit}>
              Create
            </button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    createAction: (data, handler) => {
      if (typeof handler(data) == 'function') {
        handler(data)(dispatch);
      }
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateActivityPopup);



// WEBPACK FOOTER //
// ./src/containers/Reports/createActivityPopup.js